import { ReminderFilter, ReminderPreset } from "../types";

export const REFERENCE_OPTIONS = [
  {
    parent: "Add To Zyvo",
    hint: "Add relevant notes, then click 'Save & Add to Zyvo",
    children: [
      {
        value: "Lead is qualified & relevant",
        label: "Lead is qualified & relevant",
      },
    ],
  },
  {
    parent: "Call Connected",
    hint: "Call was successfully connected",
    children: [
      {
        value: "Connected",
        label: "Call Connected",
      },
    ],
  },
  {
    parent: "No Connection",
    hint: null,
    children: [
      { value: "Not Picked", label: "Not Picked" },
      {
        value: "Not Reachable / Switch Off",
        label: "Not Reachable / Switch Off",
      },
      { value: "Invalid Number", label: "Invalid Number" },
    ],
  },
  {
    parent: "Call Disconnected",
    hint: null,
    children: [
      { value: "After Opening", label: "After Opening" },
      {
        value: "During Conversation",
        label: "During Conversation",
      },
    ],
  },
  {
    parent: "Call Later",
    hint: "Reminder date & time is required",
    children: [{ value: "Call Later", label: "Schedule a Callback" }],
  },
  {
    parent: "Reference",
    hint: null,
    children: [{ value: "Reference", label: "Gave a reference" }],
  },
  {
    parent: "Not Interested",
    hint: "Select the exact reason",
    children: [
      { value: "Distance Issue", label: "Distance Issue" },
      { value: "High Fee", label: "High Fee" },
      { value: "Govt. College", label: "Govt. College" },
      { value: "Admitted Outside", label: "Admitted Outside" },
      { value: "Others", label: "Others (explain in notes)" },
    ],
  },
];

export type GroupColors = {
  accent: string;
  bg: string;
  tagBg: string;
  tagColor: string;
};

export const GROUP_COLORS: Record<string, GroupColors> = {
  "Add To Zyvo": {
    accent: "#16a34a",
    bg: "#f0fdf4",
    tagBg: "#dcfce7",
    tagColor: "#166534",
  },
  "Call Connected": {
    accent: "#10b981",
    bg: "#f0fdf4",
    tagBg: "#dcfce7",
    tagColor: "#166534",
  },
  "No Connection": {
    accent: "#f59e0b",
    bg: "#fffbeb",
    tagBg: "#fef3c7",
    tagColor: "#92400e",
  },
  "Call Disconnected": {
    accent: "#ef4444",
    bg: "#fef2f2",
    tagBg: "#fee2e2",
    tagColor: "#991b1b",
  },
  "Call Later": {
    accent: "#1677ff",
    bg: "#eff6ff",
    tagBg: "#dbeafe",
    tagColor: "#1e40af",
  },
  Reference: {
    accent: "#10b981",
    bg: "#ecfdf5",
    tagBg: "#d1fae5",
    tagColor: "#065f46",
  },
  "Not Interested": {
    accent: "#7c3aed",
    bg: "#f5f3ff",
    tagBg: "#ede9fe",
    tagColor: "#5b21b6",
  },
  Other: {
    accent: "#6b7280",
    bg: "#f9fafb",
    tagBg: "#f3f4f6",
    tagColor: "#374151",
  },
};

export const getParentGroup = (type: string): string => {
  for (const group of REFERENCE_OPTIONS) {
    if (group.children.some((c) => c.value === type)) return group.parent;
  }
  return "Other";
};

export const getChildLabel = (type: string): string => {
  for (const group of REFERENCE_OPTIONS) {
    const child = group.children.find((c) => c.value === type);
    if (child) return child.label;
  }
  return type;
};

export const INIT_REMINDER: ReminderFilter = { preset: "", dateRange: null };

export const REMINDER_CHIPS = [
  {
    value: "" as ReminderPreset,
    label: "All",
    icon: "ti-list",
    activeColor: "#374151",
    activeBg: "#f3f4f6",
    activeBorder: "#d1d5db",
  },
  {
    value: "overdue" as ReminderPreset,
    label: "Overdue",
    icon: "ti-alert-circle",
    activeColor: "#dc2626",
    activeBg: "#fee2e2",
    activeBorder: "#fca5a5",
  },
  {
    value: "today" as ReminderPreset,
    label: "Today",
    icon: "ti-sun",
    activeColor: "#d97706",
    activeBg: "#fef3c7",
    activeBorder: "#fde68a",
  },
  {
    value: "tomorrow" as ReminderPreset,
    label: "Tomorrow",
    icon: "ti-calendar-event",
    activeColor: "#1d4ed8",
    activeBg: "#dbeafe",
    activeBorder: "#93c5fd",
  },
  {
    value: "custom" as ReminderPreset,
    label: "Custom Range",
    icon: "ti-calendar-stats",
    activeColor: "#6d28d9",
    activeBg: "#ede9fe",
    activeBorder: "#c4b5fd",
  },
];

export const LEAD_SOURCES = [
  {
    value: "Direct Calling",
    label: "Direct Calling",
    children: [
      { value: "Outbound Call (Manual)", label: "Outbound Call (Manual)" },
      { value: "Inbound Call", label: "Inbound Call" },
      { value: "Inbound via Campaign", label: "Inbound via Campaign" },
    ],
  },
  {
    value: "Messaging & Campaigns",
    label: "Messaging & Campaigns",
    children: [
      { value: "SMS Campaign", label: "SMS Campaign" },
      { value: "WhatsApp Campaign", label: "WhatsApp Campaign" },
    ],
  },
  {
    value: "Referrals",
    label: "Referrals",
    children: [
      { value: "Wholesaler/Distributor", label: "Wholesaler/Distributor" },
      { value: "Past Student Referral", label: "Past Student Referral" },
      { value: "Society Referral", label: "Society Referral" },
      { value: "Department Referral", label: "Department Referral" },
      { value: "Helpdesk", label: "Helpdesk" },
    ],
  },
  {
    value: "Social Media",
    label: "Social Media",
    children: [
      { value: "Facebook", label: "Facebook" },
      { value: "Instagram", label: "Instagram" },
      { value: "WhatsApp", label: "WhatsApp" },
    ],
  },
  {
    value: "Public Form",
    label: "Public Form",
  },
];
